<div class="main-rectangle">
    <span></span>
    <span class="terms-conditions bil-montserrat-regular">
        Term & Conditions
    </span>
    <span class="bil-right-padding-15 bil-pointer-class" (click)="closeModal()"> <img
            src="../../../../assets/images/cross.svg" /></span>
</div>
<div>
    <div>
        <div class="box-margin">
            <div>
                <span
                    class="bil-font-large bil-font-blue display-in-center bil-top-padding-10 bil-bottom-padding-10">Consumer
                    Report Consent (This title need not be
                    included) </span>
            </div>
            <div>
                <span class="bil-font-large bil-font-blue display-in-center bil-top-padding-10 bil-bottom-padding-10">
                    Format for Individual Customer Consent</span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-20">
                <span class="bil-font-large bil-font-blue text-decoration bil-font-weight">
                    CONSENT IN RELATION TO ACCESS TO CREDIT INFORMATION THROUGH EXPERIAN
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    This End User Agreement (the <span class="bil-font-weight">“Agreement”</span>) is made between
                    you
                    (the
                    <span class="bil-font-weight">“User”</span> or <span class="bil-font-weight">“You”</span>), on
                    behalf of
                    and
                    ____________________________________________________, a private limited company having its
                    registered
                    office at ________________________________________________ (<span
                        class="bil-font-weight">“Solv”</span>,
                    <span class="bil-font-weight">“Us”</span> or <span class="bil-font-weight">“We”</span>, which
                    term
                    shall
                    include its successors and permitted assigns). The User and Solv shall be collectively referred
                    to
                    as
                    the <span class="bil-font-weight">“Parties”</span> and individually as a <span
                        class="bil-font-weight">“Party”</span>.
                    You hereby consent to Solv being appointed as your authorised representative to receive your
                    Credit
                    Information from Experian for the End Use Purpose (as defined below).
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium bil-font-weight">
                    BY EXECUTING THIS AGREEMENT / CONSENT FORM, YOU ARE EXPRESSLY AGREEING TO ACCESS THE EXPERIAN
                    CREDIT
                    INFORMATION REPORT AND CREDIT SCORE, AGGREGATE SCORES, INFERENCES, REFERENCES AND DETAILS (AS
                    DEFINED
                    BELOW)(TOGETHER REFERRED AS “CREDIT INFORMATION”). YOU HEREBY ALSO CONSENT TO SUCH CREDIT
                    INFORMATION
                    BEING PROVIDED BY EXPERIAN TO YOU AND Solv BY USING EXPERIAN TOOLS, ALGORITHMS AND DEVICES AND
                    YOU
                    HEREBY AGREE, ACKNOWLEDGE AND ACCEPT THE TERMS AND CONDITIONS SET FORTH HEREIN.
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-10">
                <span class="bil-font-large bil-font-blue text-decoration bil-font-weight">
                    Terms and Conditions:
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-5">
                <span class="bil-font-xmedium bil-font-weight">
                    Information Collection, Use, Confidentiality, No-Disclosure and Data Purging
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    Solv shall access your Credit Information as your authorized representative and Solv shall use
                    the
                    Credit Information for limited End Use Purpose consisting of and in relation to the services
                    proposed to
                    be availed by you from Solv. Detailed terms with respect to the storage and use of Credit
                    Information
                    shall be as per the privacy policy available here [__Privacy policy_].

                    The Parties agree to protect and keep confidential the Credit Information both online and
                    offline.

                    The Credit Information shared by you or received by us on your behalf shall be destroyed,
                    purged,
                    erased
                    promptly within 30 days Business Days of upon the completion of the transaction/ End Use Purpose
                    for
                    which the Credit Information report was procured.
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-5">
                <span class="bil-font-xmedium bil-font-weight">
                    Governing Law and Jurisdiction
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    The relationship between you and Solv shall be governed by laws of India and all claims or
                    disputes
                    arising there from shall be subject to the exclusive jurisdiction of the courts of Mumbai.
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-5">
                <span class="bil-font-xmedium bil-font-weight">
                    Definitions:
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    Capitalized terms used herein but not defined above shall have the following meanings:
                    “Business Day” means a day (other than a public holiday) on which banks are open for general
                    business in
                    Mumbai.
                </span>
            </div>
            <div class="bil-bottom-padding-20 line-height">
                <span class="bil-font-xmedium bil-font-weight">“CICRA” &nbsp;<span
                        class="bil-font-xmedium font-weight">shall mean
                        the Credit
                        Information Companies (Regulation) Act, 2005 read with the Credit Information Companies
                        Rules,
                        2006
                        and the Credit Information Companies Regulations, 2006, and shall include any other rules
                        and
                        regulations prescribed thereunder.</span></span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <div>
                    <span class="bil-font-xmedium bil-font-weight">"Credit Information" &nbsp;<span
                            class="bil-font-xmedium font-weight">means collectively the
                            credit information as defined under the CICRA, and includes the Credit Information
                            Report
                            and
                            Credit Score;
                        </span></span>
                </div>
                <div>
                    <span class=" bil-font-xmedium bil-font-weight">“Credit Information Report”<span
                            class="bil-font-xmedium font-weight"> means the credit information / scores/ aggregates
                            /
                            variables /
                            inferences or reports which shall be generated by Experian;
                        </span></span>
                </div>
                <div>
                    <span class=" bil-font-xmedium bil-font-weight">“Credit Score<span
                            class="bil-font-xmedium font-weight">means the score which shall be mentioned on the
                            Credit
                            Information Report which
                            shall be computed by Experian.</span></span>
                </div>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 line-height">
                <span class="bil-font-xmedium bil-font-weight">"End Use Purpose &nbsp;<span
                        class="bil-font-xmedium font-weight">means use of the Credit Information being provided by
                        Experian
                        to Solv in the capacity of your authorized representative for the purpose of providing
                        financial
                        services including provisioning of personal loans, business loans, and other services from
                        banks,
                        financial institutions and other service providers and accessing financial position &
                        determining
                        financial credibility and to use such Credit Information for any related purposes, including
                        for
                        creating derivative works of the same pursuant to the User’s consent (which consent shall be
                        obtained by means of a click -wrap agreement and OTP verification) and based on the
                        agreement
                        /understanding to be entered into between Solv and the User.
                    </span></span>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 line-height">
                <span class="bil-font-xmedium font-weight">
                    PLEASE READ THE ABOVEMENTIONED TERMS AND CONDITIONS AND CLICK ON “ACCEPT” FOLLOWED BY THE LINK
                    BELOW
                    TO
                    COMPLETE THE AUTHORISATION PROCESS/ (SUBMIT YOUR SELF ATTESTED KYC DOCUMENTATION IN PHYSICAL
                    COPIES,
                    IF
                    APPLICABLE,) FOR SHARING OF YOUR CREDIT INFORMATION BY EXPERIAN WITH Solv IN ITS CAPACITY AS
                    YOUR
                    AUTHORISED REPRESENTATIVE.
                    BY CLICKING “ACCEPT” YOU AGREE AND ACCEPT THE DISCLAIMERS AND TERMS AND CONDITIONS SET OUT
                    HEREIN.
                </span>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 bil-space-around">
                <div class="bil-font-medium bil-inline-flex">
                    <div class="rectangle"></div>
                    &nbsp; Accept
                </div>
                <div class="bil-font-medium bil-inline-flex">
                    <div class="rectangle "></div>
                    &nbsp; Decline
                </div>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 line-height">
                <span class="bil-font-xmedium font-weight">
                    ** This document is an electronic record in terms of the Information Technology Act, 2000 and
                    Rules
                    made
                    there under, and the amended provisions pertaining to electronic records.
                </span>
            </div>
        </div>

        <!-- Commercial Section -->

        <div class="box-margin">
            <div>
                <span class="bil-font-large bil-font-blue display-in-center bil-top-padding-10 bil-bottom-padding-10">
                    Commercial Report consent </span>
            </div>
            <div>
                <span class="bil-font-large bil-font-blue display-in-center bil-top-padding-10 bil-bottom-padding-10">
                    Format for Commercial Customer Consent</span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-20">
                <span class="bil-font-large bil-font-blue text-decoration bil-font-weight">
                    CONSENT IN RELATION TO ACCESS TO CREDIT INFORMATION THROUGH EXPERIAN
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    This Consent Agreement (the <span class="bil-font-weight">“Agreement”</span>) is granted by
                    (Entity
                    Name) (the <span class="bil-font-weight">“User”</span> which term shall
                    include its successors and permitted assigns)) a (Legal Constitution> having its registered
                    office
                    at ________________________________________________ to Experian Credit Information Company of
                    India Private Limited authorizing (Authorised Representative Entity Name), a
                    _______________________ having its registered office at
                    ________________________________________________ (<span class="bil-font-weight">“Authorised
                        Representative”</span> which term
                    shall include its successors and permitted assigns) to receive Credit Information on its
                    behalf. The User and Authorised Representative shall be collectively referred to as the
                    <span class="bil-font-weight">“Parties”</span> and individually as a <span
                        class="bil-font-weight">““Party””</span>.
                    The User hereby consents to the Authorized Representative Entity Name being appointed as
                    authorised representative to receive the Users Credit Information from Experian for the End
                    Use Purpose (as defined below).

                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium bil-font-weight">
                    BY EXECUTING THIS AGREEMENT/ CONSENT FORM, THE USER HERERBY EXPRESSLY AGREES TO ACCESS THE
                    EXPERIAN
                    CREDIT INFORMATION REPORT AND CREDIT SCORE, AGGREGATE SCORES, INFERENCES, REFERENCES AND DETAILS
                    (AS
                    DEFINED BELOW)(TOGETHER REFERRED AS “CREDIT INFORMATION”).
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium bil-font-weight">
                    THE USER HEREBY ALSO IRREVOCABLY AND UNCONDITIONALLY CONSENTS TO SUCH CREDIT INFORMATION BEING
                    PROVIDED
                    BY EXPERIAN TO THE USER AND AUTHORISED REPRESENTATIVE BY USING EXPERIAN TOOLS, ALGORITHMS AND
                    DEVICES
                    AND THE USER HEREBY AGREES, ACKNOWLEDGES AND ACCEPTS THE TERMS AND CONDITIONS SET FORTH HEREIN.
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-10">
                <span class="bil-font-large bil-font-blue text-decoration bil-font-weight">
                    Terms and Conditions:
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-5">
                <span class="bil-font-xmedium bil-font-weight">
                    Information Collection, Use, Confidentiality, No-Disclosure and Data Purging
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    The Authorised Representative shall access the Users Credit Information as the User’s authorized
                    representative and the Authorised Representative shall use the Credit Information for the
                    limited
                    End
                    Use Purpose consisting of and in relation to the services proposed to be availed by the User
                    from
                    the
                    Authorised Representative.
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    The Parties agree to protect and keep confidential the Credit Information both online and
                    offline.
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    The Credit Information shared by the User, or received by the Authorised Representative, shall
                    be
                    destroyed, purged, erased promptly within 30 Business Days of upon the completion of the
                    transaction/
                    End Use Purpose for which the Credit Information report was procured.
                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-5">
                <span class="bil-font-xmedium bil-font-weight">
                    Governing Law and Jurisdiction
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    The relationship between the User and the Authorised Representative for the purposes of this
                    consent
                    agreement shall be governed by laws of India and all claims or disputes arising there from shall
                    be
                    subject to the exclusive jurisdiction of the courts of Mumbai.

                </span>
            </div>
            <div class="bil-top-padding-10 bil-bottom-padding-5">
                <span class="bil-font-xmedium bil-font-weight">
                    Definitions:
                </span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <span class="bil-font-xmedium">
                    Capitalized terms used herein but not defined above shall have the following meanings:
                    “Business Day” means a day (other than a public holiday) on which banks are open for general
                    business in
                    Mumbai.

                </span>
            </div>
            <div class="bil-bottom-padding-20 line-height">
                <span class="bil-font-xmedium bil-font-weight">“CICRA” &nbsp;<span
                        class="bil-font-xmedium font-weight">shall mean the Credit Information Companies
                        (Regulation)
                        Act,
                        2005 read with the Credit Information Companies Rules, 2006 and the Credit Information
                        Companies
                        Regulations, 2006, and shall include any other rules and regulations prescribed thereunder
                    </span></span>
            </div>
            <div class="bil-bottom-padding-10 line-height">
                <div>
                    <span class="bil-font-xmedium bil-font-weight">"Credit Information" &nbsp;<span
                            class="bil-font-xmedium font-weight">" means collectively the credit information as
                            defined
                            under the CICRA, and includes the Credit Information Report and Credit Score;
                        </span></span>
                </div>
                <div>
                    <span class=" bil-font-xmedium bil-font-weight">“Credit Information Report”<span
                            class="bil-font-xmedium font-weight"> means the credit information / scores/ aggregates
                            /
                            variables / inferences or reports which shall be generated by Experian;
                        </span></span>
                </div>
                <div>
                    <span class=" bil-font-xmedium bil-font-weight">“Credit Score<span
                            class="bil-font-xmedium font-weight">means the score which shall be mentioned on the
                            Credit
                            Information Report which shall be computed by Experian.</span></span>
                </div>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 line-height">
                <span class="bil-font-xmedium bil-font-weight">"End Use Purpose &nbsp;<span
                        class="bil-font-xmedium font-weight"> means use of the Credit Information being provided by
                        Experian
                        to SC in the capacity of your authorized representative for the purpose of providing
                        financial
                        services including provisioning of personal loans, business loans, and other services from
                        banks,
                        financial institutions and other service providers, and assessing financial position and
                        determining
                        the financial credibility, and to use such Credit Information for any related purposes,
                        including
                        for creating derivative works of the same, pursuant to the User's consent (which consent
                        shall
                        be
                        obtained by means of a click-wrap agreement and OTP verification) and based on the
                        agreement/understanding to be entered into between SC and the User.
                    </span></span>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 line-height">
                <span class="bil-font-xmedium font-weight">
                    PLEASE READ THE ABOVEMENTIONED TERMS AND CONDITIONS AND CLICK ON “ACCEPT” FOLLOWED BY THE LINK
                    BELOW
                    TO
                    COMPLETE THE AUTHORISATION PROCESS/ (SUBMIT YOUR SELF ATTESTED KYC DOCUMENTATION IN PHYSICAL
                    COPIES,
                    IF
                    APPLICABLE,) FOR SHARING OF YOUR CREDIT INFORMATION BY EXPERIAN WITH SC IN ITS CAPACITY AS YOUR
                    AUTHORISED REPRESENTATIVE.
                    BY CLICKING “ACCEPT” YOU AGREE AND ACCEPT THE DISCLAIMERS AND TERMS AND CONDITIONS SET OUT
                    HEREIN.
                </span>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 bil-space-around">
                <div class="bil-font-medium bil-inline-flex">
                    <div class="rectangle "></div>
                    &nbsp; Accept
                </div>
                <div class="bil-font-medium bil-inline-flex">
                    <div class="rectangle "></div>
                    &nbsp; Decline
                </div>
            </div>
            <div class="bil-bottom-padding-20 bil-top-padding-20 line-height">
                <span class="bil-font-xmedium font-weight">
                    ** This document is an electronic record in terms of the Information Technology Act, 2000 and
                    Rules
                    made
                    there under, and the amended provisions pertaining to electronic records.
                </span>
            </div>
        </div>
    </div>
</div>